module.exports = __webpack_public_path__ + "static/fonts/Quicksand-Regular.f46f486.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Quicksand-Regular.ttf
// module id = dFUr
// module chunks = 1